import { toTitleCase } from '../Utils/CommonUtils';
import { SearchAPIHits, SUGGESTION_LIST_TYPE } from './types';

export const getSuggestionList = (
  listData: Array<SearchAPIHits>
): Array<SUGGESTION_LIST_TYPE> => {
  const SUGGESTION_LIST: Array<SUGGESTION_LIST_TYPE> = [];
  listData.forEach((ele) => {
    SUGGESTION_LIST.push({
      bank_name: {
        id: 'bank_name',
        label: 'Bank',
        value: toTitleCase(ele.bank_name),
      },
      ifsc_code: {
        id: 'ifsc',
        label: 'IFSC',
        value: ele.ifsc_code,
      },
      branch_name: {
        id: 'branch',
        label: 'Branch',
        value: toTitleCase(ele.branch_name),
      },
      city: {
        id: 'city',
        label: 'City',
        value: toTitleCase(ele.city),
      },
      state: {
        id: 'state',
        label: 'State',
        value: toTitleCase(ele.state),
      },
      address: {
        id: 'address',
        label: 'Address',
        value: ele.address,
      },
    });
  });
  if (!SUGGESTION_LIST.length) {
    SUGGESTION_LIST.push({
      bank_name: {
        id: 'bank_name',
        label: '',
        value: 'No Result Found',
      },
    });
  }
  return SUGGESTION_LIST;
};
